module.exports = __webpack_public_path__ + "img/empty-oil.80aa76a4.png";